import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from 'lodash';
import {PlanningDraftsService} from "../../services/planning-drafts-service.service";
import {PlanningProjectsService} from "../../services/planning-projects-service.service";
import {PlanningDialogService} from "../../services/planning-dialogs-service.service";
import {PlanningDraftExportType} from "../../types/planning-draft-export.type";

export class PlanningProjectCompletedViewCtrl implements IController {

  project: any;
  draft: any;
  analysis: any;
  jobs: any;
  routes: any;

  public selectedJobIds: any[];
  public selectedActivityId: any;
  public timelineEnabled: any;
  public hiddenRouteIds: any[];
  public highlightedActivityId: any;
  public leftoverJobs: any;
  public leftoverStops: any;
  private isTimelineFullScreen: any;
  private projectRef: any;
  private projectColorMap: any;
  private selectedLeftoverIds: any;
  public planningDraftExportType: typeof PlanningDraftExportType = PlanningDraftExportType;

  /* @ngInject */
  constructor(private $planningProjects, private planningConstants, private planningProjectsService: PlanningProjectsService,
              private planningDraftsService: PlanningDraftsService, private $log, private $timeout: ITimeoutService,
              private planningDialogService: PlanningDialogService) {
    this.projectRef = $planningProjects;
    this.projectColorMap = planningConstants.projectStatusColorMap;

  }

  $onInit() {
    this.selectedJobIds = [];
    this.selectedActivityId = undefined;
    this.highlightedActivityId = undefined;
    this.isTimelineFullScreen = false;
    this.hiddenRouteIds = [];
    this._setLeftoversByJobIds(this.draft.leftoversIds);
    this.$timeout(1000).then(() => {
      this.timelineEnabled = true;
    })
    // this.hiddenRouteIds = _.map(this.routes, 'id');
  }

  // ******************************
  //        Public methods
  // ******************************

  // Drafts
  onExportReport() {
    this.planningDraftsService.exportDraftReport(this.project.id, this.draft.id)
      .then(function (res) {

      });
  }

  onExportDraftSvg(exportType) {
    this.planningDraftsService.exportDraft(this.project.id, this.draft.id, exportType)
      .then(function (res) {
      })
  }

  // Map Interactions
  onRoutedStopSelect(stop) {
    this.$log.info(stop)
  }

  onHiddenRouteIdsChange(ids) {
    this.hiddenRouteIds = ids;
  }

  // Timeline
  onToggleRouteDisplay(id, isEnabled) {
    if (isEnabled) {
      this.hiddenRouteIds = _.filter(this.hiddenRouteIds, function (rid) {
        return rid !== id;
      })
    } else {
      this.hiddenRouteIds = this.hiddenRouteIds.concat([id]);
    }
  }

  onToggleAllRouteDisplay(isEnabled) {
    this.hiddenRouteIds = isEnabled ? [] :
      _.map(this.routes, function (r) {
        return r.id;
      })
  }

  onActivitySelection(activityId) {
    this.selectedActivityId = activityId;
  }

  onActivityHighlight(activity, $event) {
    this.highlightedActivityId = _.get(activity, 'activityId');
  }

  onToggleTimeline() {
    this.timelineEnabled = !this.timelineEnabled;

    if (!this.timelineEnabled) {
      this.isTimelineFullScreen = false;
    }
  }

  onTimelineFullScreen(event) {
    this.isTimelineFullScreen = !this.isTimelineFullScreen;
    this.timelineEnabled = true;

    const timelineElement = document.getElementById('planning-timeline');
    const height = this.isTimelineFullScreen ? window.innerHeight : (window.innerHeight / 2);
    timelineElement.style.height = height + 'px';
  }

  // Leftovers
  onLeftOverJobSelect(jobId) {
    if (!_.includes(this.selectedJobIds, jobId)) {
      this.selectedJobIds = this.selectedJobIds.concat([jobId]);
    } else {
      this.selectedJobIds = _.filter(this.selectedJobIds, (id) => {
        return id !== jobId;
      })
    }
    this._setSelectedLeftoverIds(this.selectedJobIds);
    this.$log.info(jobId);
  }

  setAllLeftOverSelection(isSelectAll) {
    this.selectedJobIds = isSelectAll ? _.map(this.leftoverJobs, 'id') : [];
    this._setSelectedLeftoverIds(this.selectedJobIds);
  }

  onExportDraftRoutesLoadingSheetSvg(routeIds?) {
    this.planningDialogService.exportDraftLoadingSheet()
      .then((email?) => {
        this._exportDraftRoutesLoadingSheetSvg(routeIds, email);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _exportDraftRoutesLoadingSheetSvg(routeIds?, email?) {
    this.planningDraftsService.exportDraft(this.project.id, this.draft.id, PlanningDraftExportType.ROUTES_LOADING, routeIds, email)
      .then(() => {
      })
      .catch((error) => {
        this.$log.error(error);
      })
  }

  private _setLeftoversByJobIds(leftoversIds) {
    const leftoverJobs = _.filter(this.jobs, (j) => {
      return _.includes(leftoversIds, j.id)
    });
    this.leftoverJobs = leftoverJobs;
    this.leftoverStops = this._getLeftoverStops(leftoverJobs);
  }

  private _getLeftoverStops(jobs) {
    let stops = [];

    _.forEach(jobs, function (j) {
      _.forEach(j.stops, function (s) {
        stops.push(s);
      })
    });
    return stops;
  }

  private _setSelectedLeftoverIds(selectedJobIds) {
    const leftoverJobsIds = _.map(this.leftoverJobs, 'id');
    this.selectedLeftoverIds = _.filter(selectedJobIds, function (id) {
      return _.includes(leftoverJobsIds, id);
    })
  }

}


angular
  .module('bringoz.admin.planning')
  .component('planningProjectCompletedView', {
    bindings: {
      project: '<',
      draft: '<',
      analysis: '<',
      jobs: '<',
      routes: '<'
    },
    template: require('./planning-project-completed-view.html').default,
    controller: PlanningProjectCompletedViewCtrl
  });
